const integrations = {
  metadata: {
    required: "Preencha os campos obrigatórios antes de conectar esta ferramenta.",
    tab: "Metadados",
    valuePlaceholder: "valor",
  },
  models: {
    problem: {
      emptyName: "Há um modelo sem nome.",
      duplicate: "{{model}}: nome repetido.",
      missingApi: "{{model}}: escolha a rota.",
      missingDimensions: "{{model}}: informe as dimensões (tamanho do vetor).",
      invalidDimensions: "{{model}}: as dimensões devem ser um número inteiro positivo.",
    },
    empty: "Nenhum modelo cadastrado.",
    add: "Adicionar modelo",
    remove: "Remover modelo",
    namePlaceholder: "nome do modelo ou deployment",
    apiPlaceholder: "rota",
    apiVersionPlaceholder: "api-version",
    apiVersionSuspect:
      "Este valor não tem o formato de data que os provedores usam na api-version. Confira antes de salvar.",
    apiVersionHint:
      "A api-version é a versão da API REST do provedor, não a versão do modelo que aparece no portal dele. Ela vale só para este modelo: rotas diferentes do mesmo recurso podem exigir versões diferentes.",
    dimensionsPlaceholder: "dimensões",
    serves: "atende o modelo {{model}}",
    invalid: "Revise os modelos: cada um precisa de nome e rota, e os de indexação precisam das dimensões.",
  },
  title: "Tools",
  description: "Integre todas suas ferramentas em um só lugar",
  kind: {
    mcp: "Servidor MCP",
    api: "Conector de API"
  },
  review: {
    pending: "Aguardando revisão"
  },
  mcp: {
    serverUrl: "URL do servidor",
    authMode: "Autenticação",
    authModes: {
      none: "Nenhuma",
      bearer: "Token Bearer",
      apikey: "Chave de API",
      oauth: "OAuth"
    },
    authHeader: "Nome do header",
    apiKey: "Chave de API",
    token: "Token",
    toolsSyncedAt: "Ferramentas sincronizadas em {{date}}",
    noAuthHint: "Este servidor não exige autenticação.",
    add: {
      title: "Adicionar servidor MCP",
      urlStep: "Informe a URL do servidor MCP remoto.",
      detailsStep: "Dê um nome a esta instalação e escolha onde ela fica disponível.",
      inspect: "Inspecionar",
      connecting: "Conectando ao servidor para ver como ele autentica e quais tools oferece…",
      connectFailed: "Não foi possível falar com o servidor.",
      retry: "Tentar de novo",
      urlHint: "O Prodgy conecta no servidor para descobrir como ele autentica e quais ferramentas oferece. Nada é gravado ainda.",
      invalidUrl: "Informe uma URL http(s) válida.",
      oauthStartFailed: "A ferramenta foi criada, mas a autorização não começou. Clique em Reconectar na aba Conexão.",
      alreadyInCatalog: "Este servidor já está no catálogo como {{name}}. Você vai instalar esse template.",
      oauthHint: "Este servidor usa OAuth. Ao confirmar, você será redirecionado ao provedor para autorizar o acesso.",
      previewTools: "Ver ferramentas",
      toolsAfterOauth: "As ferramentas aparecem depois que você autorizar o acesso.",
      connectOauth: "Conectar e autorizar"
    }
  },
  oauth: {
    label: "OAuth",
    connected: "Servidor conectado",
    connectedRefreshFailed: "Autorizado, mas a lista de tools não veio. Atualize as tools na aba Tools.",
    failed: "A autorização falhou",
    status: {
      pending: "Autorização pendente",
      connected: "Conectado",
      reconnect: "Precisa reconectar"
    },
    connectedHint: "O acesso está autorizado. Reconecte se precisar trocar a conta ou as permissões.",
    pendingHint: "O acesso não está autorizado. Reconecte para autorizar no provedor.",
    reconnect: "Reconectar"
  },
  connection: {
    keepCredential: "Deixe em branco para manter a credencial atual.",
    noFields: "Esta ferramenta não tem configurações de conexão."
  },
  detail: {
    back: "Voltar para Tools",
    notFound: "Não encontramos esta ferramenta.",
    tabs: {
      general: "Geral",
      connection: "Conexão",
      tools: "Ferramentas",
      usage: "Uso"
    }
  },
  tools: {
    title: "Ferramentas",
    count_one: "{{count}} ferramenta",
    count_other: "{{count}} ferramentas",
    empty: "Nenhuma ferramenta.",
    states: {
      enabled: "Ativa",
      confirm: "Pede confirmação",
      blocked: "Bloqueada"
    },
    columns: {
      name: "Nome",
      description: "Descrição",
      method: "Método",
      state: "Estado"
    },
    showSchema: "Ver parâmetros",
    add: "Adicionar ferramenta",
    addTitle: "Adicionar ferramenta",
    editTitle: "Editar ferramenta",
    dialogDescription: "A chamada REST que os agentes fazem ao usar esta ferramenta.",
    endpoint: "Endpoint",
    inputSchema: "Parâmetros (JSON Schema)",
    inputSchemaHint: "Um objeto JSON Schema descrevendo os parâmetros que a ferramenta recebe.",
    problems: {
      nameRequired: "Informe um nome.",
      nameInvalid: "Use só letras, números, sublinhado, ponto e hífen (até 128 caracteres).",
      nameTaken: "Já existe uma ferramenta com este nome.",
      endpointRequired: "Informe o endpoint.",
      schemaInvalidJson: "Isto não é um JSON válido.",
      schemaNotObject: "O schema precisa ser um objeto JSON."
    },
    removeTitle: "Remover ferramenta",
    removeConfirm: "Remover a ferramenta {{name}} desta instalação? Os agentes deixam de vê-la.",
    removed: "Ferramenta {{name}} removida",
    compareTemplate: "Comparar com o template",
    refreshFromServer: "Atualizar do servidor",
    diff: {
      refreshTitle: "Atualizar do servidor",
      refreshDescription: "O que mudou no servidor desde a última sincronização. Os agentes só veem as mudanças depois que você aceitar.",
      refreshSummary: "{{added}} novas · {{changed}} alteradas · {{removed}} removidas do servidor",
      removedFromServer: "Removida do servidor",
      affectedSkills_one: "{{count}} skill usa ferramentas que vão mudar ou sair:",
      affectedSkills_other: "{{count}} skills usam ferramentas que vão mudar ou sair:",
      acceptRefresh: "Aceitar mudanças",
      templateTitle: "Comparar com o template",
      templateDescription: "Ferramentas que diferem entre esta instalação e o template. Escolha quais trazer do template; marcar uma que só existe aqui a remove.",
      none: "Nenhuma diferença.",
      summary: "{{added}} novas no template · {{changed}} alteradas · {{removed}} só nesta instalação",
      added: "Adicionada",
      removed: "Só nesta instalação",
      changed: "Alterada",
      applySelected: "Aplicar selecionadas",
      applied: "Ferramentas atualizadas",
      serverChanged: "O servidor mudou as tools desde a prévia. Revise as mudanças novas antes de aplicar."
    }
  },
  usage: {
    empty: "Nenhuma chamada registrada ainda.",
    byTool: "Chamadas por ferramenta",
    window_one: "Com base na última chamada.",
    window_other: "Com base nas últimas {{count}} chamadas.",
    recent: "Chamadas recentes",
    columns: {
      tool: "Ferramenta",
      when: "Quando",
      status: "Status"
    },
    status: {
      success: "Sucesso",
      error: "Erro"
    }
  },
  empty: {
    title: "Nenhuma ferramenta encontrada",
    description: "Configure uma nova ferramenta para começar"
  },
  new: {
    title: "Nova ferramenta",
    description: "Configure uma nova ferramenta"
  },
  form: {
    name: "Nome",
    description: "Descrição",
    type: "Tipo",
    status: "Status",
    authType: "Tipo de Autenticação",
    selectAuthType: "Selecione um tipo de autenticação",
    title: {
      label: "Nome da ferramenta",
      placeholder: "Ex: Jira da Squad Mobile",
      required: "O nome da ferramenta é obrigatório",
      taken: "Já existe uma ferramenta com este nome na organização. Escolha outro.",
      hint: "O nome identifica esta instalação e é único na organização."
    },
    errors: {
      requiredFields: "Campos obrigatórios não preenchidos: {{fields}}",
      create: "Erro ao criar ferramenta. Verifique os dados e tente novamente.",
      update: "Erro ao atualizar ferramenta. Verifique os dados e tente novamente.",
      unknown: "Erro desconhecido"
    },
    defaultDescription: "Ferramenta configurada via Prodgy"
  },
  status: {
    active: "Ativa",
    inactive: "Inativa",
    pending: "Pendente",
    awaitingConnection: "Aguardando conexão — clique para conectar",
    failed: "Falha",
    connected: "Conectada",
    disconnected: "Desconectada",
    syncing: "Sincronizando",
    synced: "Sincronizada",
    unknown: "Desconhecido"
  },
  fields: {
    apiKey: "Chave da API",
    model: "Modelo",
    clientId: "ID do Cliente",
    clientSecret: "Chave Secreta do Cliente",
    accessToken: "Token de Acesso",
    redirectUri: "URI de Redirecionamento",
    privateToken: "Token Privado",
    gitlabUrl: "URL do GitLab",
    gitlabProjectId: "ID do Projeto GitLab",
    organization: "Organização",
    googleProjectId: "ID do Projeto Google",
    username: "Usuário",
    password: "Senha",
    scope: "Escopo",
    apiKeyPlaceholder: "Digite sua chave da API OpenRouter",
    modelPlaceholder: "Digite o nome do modelo (ex: openai/gpt-4)",
    clientIdPlaceholder: "Digite o ID do Cliente",
    clientSecretPlaceholder: "Digite a Chave Secreta do Cliente",
    accessTokenPlaceholder: "Digite o Token de Acesso",
    redirectUriPlaceholder: "Digite a URI de Redirecionamento",
    privateTokenPlaceholder: "Digite o Token Privado",
    gitlabUrlPlaceholder: "Digite a URL do GitLab",
    gitlabProjectIdPlaceholder: "Digite o ID do Projeto GitLab",
    organizationPlaceholder: "Digite o nome da Organização",
    googleProjectIdPlaceholder: "Digite o ID do Projeto Google",
    usernamePlaceholder: "Digite o usuário",
    passwordPlaceholder: "Digite a senha",
    scopePlaceholder: "Digite o escopo"
  },
  actions: {
    connect: "Conectar",
    disconnect: "Desconectar",
    save: "Salvar alterações",
    cancel: "Cancelar",
    test: "Testar conexão",
    sync: "Sincronizar",
    update: "Atualizar",
    connecting: "Conectando...",
    updating: "Atualizando...",
    remove: "Remover",
    configure: "Configurar"
  },
  messages: {
    copyFailed: "Não foi possível copiar. Selecione o valor e copie manualmente.",
    connected: "Ferramenta conectada com sucesso",
    disconnected: "Ferramenta desconectada com sucesso",
    saved: "Alterações salvas com sucesso",
    error: "Erro ao processar a operação",
    authUpdated: "Configurações de autenticação atualizadas com sucesso",
    authUpdateError: "Falha ao atualizar configurações de autenticação",
    connectionTestFailed: "Teste de conexão falhou. Por favor, verifique suas credenciais e tente novamente.",
    cannotDelete: "Não é possível remover ferramenta",
    deleteSuccess: "foi removido com sucesso!",
    deleteError: "Erro ao remover ferramenta. Tente novamente.",
    hasDependencies: "Esta ferramenta está sendo usada por {{dependencies}}. Remova essas dependências antes de excluir a ferramenta."
  },
  searchPlaceholder: "Pesquise por ferramentas...",
  searchTools: "Pesquise por ferramentas...",
  addIntegration: "Adicionar ferramenta",
  add: "Adicionar",
  encrypted: "Criptografado",
  configure: "Configurar",
  lastValidated: "Última validação",
  selectTemplate: "Selecione a ferramenta que deseja integrar ao Prodgy",
  select: "Selecionar",
  sections: {
    settings: "Configurações",
    authentication: "Autenticação"
  },
  placeholders: {
    select: "Selecione...",
    enterField: "Digite {{field}}"
  },
  defaultFields: {
    integrationName: "Nome da ferramenta",
    integrationNamePlaceholder: "Digite um nome para esta ferramenta",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Editar",
    editTitle: "Editar {{name}}",
    updateSettings: "Atualize as configurações e credenciais da ferramenta",
    configureIntegration: "Configure a ferramenta"
  },
  scope: {
    label: "Escopo",
    addTo: "Adicionar a ferramenta a...",
    workspaceOnly: "Somente ao workspace",
    globalAll: "Toda a organização",
    sectionWorkspace: "Do Workspace",
    sectionOrganization: "De toda a organização",
    missingOrg: "Não foi possível identificar a organização atual.",
    missingWorkspace: "Selecione um workspace ou marque a ferramenta como global.",
    permissionsLabel: "Permissões",
    productLabel: "Produto",
    organizationLabel: "Organização",
    organizationHint: "Esta ferramenta ficará disponível para uso em todos os produtos da organização.",
    productHint: "Esta ferramenta ficará disponível apenas no workspace atual, ao lado das ferramentas da organização.",
    product: "Este produto",
    general: "Global"
  },
  postInstall: {
    title: "Ferramenta criada — próximos passos",
    subtitle: "Configure {{name}} usando os valores abaixo e siga as instruções para concluir a instalação.",
    copied: "URL copiada",
    copyFailed: "Falha ao copiar",
    copy: "Copiar",
    instructionsLabel: "Instruções de configuração",
    confirm: "Entendi",
    manifestLabel: "App Manifest",
    copyManifest: "Copiar JSON",
    downloadZip: "Baixar ZIP",
    zipBuilding: "Gerando...",
    zipFailed: "Falha ao gerar o pacote ZIP"
  },
   delete: {
    title: "Remover ferramenta",
    confirmMessage: "Tem certeza de que deseja remover a ferramenta <strong>{{name}}</strong>?",
    warning: "Esta ação não pode ser desfeita. Todas as configurações e credenciais serão permanentemente perdidas.",
    removing: "Removendo...",
    confirm: "Sim, Remover"
  },
  selector: {
    kindFilter: "Tipo de ferramenta",
    kinds: {
      mcp: "Servidores MCP",
      api: "Conectores de API"
    },
    noMcpServers: "Nenhum servidor MCP encontrado",
    noMcpServersHint: "Adicione um servidor MCP remoto pela URL.",
    notFound: "Não encontrou?",
    addMcpServer: "Adicionar servidor MCP",
    noIntegrations: "Nenhuma ferramenta",
    noToolsFound: "Nenhuma ferramenta encontrada",
    resultCount_one: "{{count}} ferramenta",
    resultCount_other: "{{count}} ferramentas",
    filtered_one: "filtrada",
    filtered_other: "filtradas",
    forQuery: "para \"{{query}}\"",
    requiredNotInstalled: "A ferramenta exigida pelo fluxo não está instalada",
    addNewPrompt: "Ou adicione uma nova ferramenta...",
    addFirstPrompt: "Adicione uma ferramenta para começar...",
    templateDescription: "Template de ferramenta"
  }
} as const;

export default integrations;
